// extracted by mini-css-extract-plugin
module.exports = {"circled-angle":"circled-angle-7GI","pin":"pin-3rd","phone":"phone-1z_","circle-arrow":"circle-arrow-1yO","arrow-right":"arrow-right-kRr","info":"info-3cp","icon":"icon-2MB"};